import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from './components/error/error.component';
import { LoginComponent } from './components/login/login.component';
import { NotAuthGuard } from './services/guards/auth-not.guard';
import { InfoComponent } from './components/info/info.component';
import { SettingsComponent } from './components/settings/settings.component';
import { OutboundComponent } from './components/outbound/outbound.component';
import { NotAvailableReasonComponent } from './components/not-available-reason/not-available-reason.component';
import { AppRoutes } from './enums/app-routes';
import { ShellComponent } from './components/shell/shell.component';
import { HomeComponent } from './components/shell/home/home.component';
import { TaskDetailsComponent } from './components/shell/task-details/task-details.component';

/**
 * MSAL Angular can protect routes in your application
 * using MsalGuard. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#secure-the-routes-in-your-application
 */

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        redirectTo: AppRoutes.home,
        pathMatch: 'full',
      },
      {
        path: AppRoutes.call,
        component: TaskDetailsComponent,
        canActivate: [MsalGuard],
        data: { trackingModule: 'Call' },
      },
      {
        path: AppRoutes.home,
        component: HomeComponent,
        canActivate: [MsalGuard],
        data: { trackingModule: 'Home' },
      },
      {
        path: AppRoutes.outbound,
        component: OutboundComponent,
        data: { trackingModule: 'Outbound' },
      },
      {
        path: AppRoutes.notAvailableReason,
        component: NotAvailableReasonComponent,
        data: { trackingModule: 'Not Available Reason' },
      },
    ],
  },
  {
    path: AppRoutes.error,
    component: ErrorComponent,
  },
  {
    path: AppRoutes.info,
    component: InfoComponent,
  },
  {
    path: AppRoutes.login,
    component: LoginComponent,
    canActivate: [NotAuthGuard],
  },
  {
    path: AppRoutes.settings,
    component: SettingsComponent,
    data: { trackingModule: 'Settings' },
  },
  {
    path: '**',
    redirectTo: AppRoutes.login,
  },
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: !isIframe ? 'enabledNonBlocking' : 'disabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
